import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiHalfsmileOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.8 12c0-2.392.088-4.14.334-5.446.243-1.289.608-1.97 1.03-2.39.42-.422 1.101-.787 2.39-1.03C7.86 2.888 9.608 2.8 12 2.8s4.14.088 5.446.334c1.289.243 1.97.608 2.39 1.03.422.42.787 1.101 1.03 2.39.246 1.306.334 3.054.334 5.446s-.088 4.14-.334 5.446c-.243 1.289-.608 1.97-1.03 2.39-.42.422-1.101.787-2.39 1.03-1.306.246-3.054.334-5.446.334s-4.14-.088-5.446-.334c-1.289-.243-1.97-.608-2.39-1.03-.422-.42-.787-1.101-1.03-2.39C2.888 16.14 2.8 14.392 2.8 12M1 12C1 2.375 2.375 1 12 1s11 1.375 11 11-1.375 11-11 11S1 21.625 1 12m9.656 4.584c-.18-.191-.256-.393-.256-.584H8.6c0 .71.295 1.339.744 1.816.644.686 1.617 1.084 2.656 1.084s2.012-.398 2.656-1.084c.448-.477.744-1.106.744-1.816h-1.8c0 .19-.076.393-.256.584-.268.285-.747.516-1.344.516s-1.076-.23-1.344-.516M13.75 9.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75M8.5 7.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.437-1.75-1.75-1.75"
                fill="currentColor"
            />
        </svg>
    )
);
EmojiHalfsmileOutlinedSize24Glyph.displayName = 'EmojiHalfsmileOutlinedSize24Glyph';
